import createAxiosInstance from './axiosConfig';
import { AgendarRelatorioDTO, MoverRelatorioDTO } from '../shared/dto/agendarRelatorioDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(`${REACT_APP_ESTEIRA_BACK}/rest/relatoriosAgendados`);

export interface ProgressoRelatorio {
  id: string;
  status: string;
  progressoDisponivel?: boolean;
  progressoPorcentagem?: number;
  linhasProcessadas?: number;
  totalLinhas?: number;
  tempoEstimadoRestante?: string;
  tempoDecorrido?: string;
  pausado?: boolean;
}

export default class RelatoriosAgendadosService {
  private axios;

  constructor() {
    this.axios = axiosInstance;
  }

  async solicitarRelatorio(dto: AgendarRelatorioDTO) {
    try {
      const response = await this.axios.post('/solicitar', dto, {
        responseType: 'json',
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async progresso(id: string) {
    try {
      const response = await this.axios.get(`/progresso/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async listar(id: string, page = 0, size = 10, sortBy = 'dtaCriacao', sortDirection = 'desc') {
    try {
      const response = await this.axios.get(`/listar/${id}`, {
        params: {
          page,
          size,
          sortBy,
          sortDirection
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async downloadRelatorio(id: string, config: any) {
    try {
      const response = await this.axios.get(`/download/${id}`, config);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async pausarProcessamento(id: string, userId: string) {
    try {
      const response = await this.axios.post(`/pausar/${id}`, { userId });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async retomarProcessamento(id: string, userId: string) {
    try {
      const response = await this.axios.post(`/retomar/${id}`, { userId });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async cancelarProcessamento(id: string, userId: string) {
    try {
      const response = await this.axios.post(`/cancelar/${id}`, { userId });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async moverNaFila(dto: MoverRelatorioDTO) {
    try {
      const response = await this.axios.post('/mover', dto, {
        responseType: 'json',
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  async monitorarProgresso(
    id: string, 
    onUpdate: (progresso: ProgressoRelatorio) => void,
    onComplete: () => void,
    interval = 1500
  ): Promise<NodeJS.Timeout> {
    const intervalId = setInterval(async () => {
      try {
        const response = await this.progresso(id);
        const dados: ProgressoRelatorio = response.data;
        
        onUpdate(dados);

        if (dados.status === 'COMPLETED' || dados.status === 'FAILED') {
          clearInterval(intervalId);
          onComplete();
        }
      } catch (error) {
        console.error('Erro ao monitorar progresso:', error);
      }
    }, interval);

    return intervalId;
  }
}